import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';
declare let kendo;


@Component({
    selector: 'unit-one-lesson-one-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['./_guide.component.css']
})

export class UnitOneLessonOneGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 1, Lesson 1 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 1: Strengths";


    doPrint(): void {
        window.print();
    }

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
 }
